import { AppDependencies } from "./providers/AppDependenciesProvider";
import { DocumentationAreaController } from "src/contexts/documentationArea/application/DocumentationAreaController";
import { StaticDocumentationAreaRepository } from "src/contexts/documentationArea/infrastructure/static/StaticDocumentationAreaRepository";
import { StaticTranslationRepository } from "src/contexts/translation/infrastructure/StaticTranslationRepository";
import { TranslationController } from "src/contexts/translation/application/TranslationController";
import { AuthController } from "src/contexts/auth/application/AuthController";
import { StaticAuthRepository } from "src/contexts/auth/infrastructure/StaticAuthRepository";
import { withFailureInjection } from "./StaticFailureInjection";

export const staticAppDependencies = (): AppDependencies => {
  const documentationAreaRepository = withFailureInjection(new StaticDocumentationAreaRepository());
  const documentationAreaController = new DocumentationAreaController({
    documentationAreaRepository: documentationAreaRepository,
  });

  const translationRepository = withFailureInjection(new StaticTranslationRepository());
  const translationController = new TranslationController({
    translationRepository,
  });

  const authRepository = withFailureInjection(new StaticAuthRepository());
  const authController = new AuthController({
    authRepository,
  });

  return {
    documentationAreaController,
    translationController,
    authController,
  };
};
